<div class="search-container" *ngIf="esRutaCatalogo()">
    <form [formGroup]="formSearch" autocomplete="off" (submit)="search()">
        <!-- <button class="search-button">
            <i class="fas fa-search"></i>
        </button>
        <input type="text" #txtBusqueda formControlName="busqueda" class="input-buscador" name="busqueda" placeholder="Buscar productos" />
    
        <span *ngIf="mostrarBoton" mat-raised-button class="small-grey-button aladerecha" (click)="copiarClipboard()"><mat-icon>content_copy</mat-icon></span> -->
        <div class="text-center">

            <select [(ngModel)]="tagDesdeUrl"  [ngModelOptions]="{standalone: true}" class="select-search" (change)="onSelectChange($event)">
                <option value="recientes">Productos Recientes</option>
                <option value="vendidos">Más Vendidos</option>
                <option [value]="getTagValue(tag)"  *ngFor="let tag of tags.registros; let i = index;" (click)="tomarTag(tag.idmodelo,tag.marca_modelo)">{{ tag.marca_modelo }}</option>
            </select>
            <span *ngIf="mostrarBoton" mat-raised-button class="small-grey-button aladerecha" (click)="copiarClipboard()"><mat-icon>content_copy</mat-icon></span>
        </div>
    </form>
</div>

  